import viLang from './vi.es.js';
import enLang from './en.es.js';

const lang = {
  vi: viLang,
  en: enLang
};
var lang$1 = lang;

export { lang$1 as default };
